import { connect } from 'react-redux';
import { branch, lifecycle, mapProps, renderComponent, withState } from 'recompose';
import * as R from 'ramda';

import { logout } from '../../redux/actions/auth';
import { setSearchTerm } from '../../redux/actions/global';
import NavigationComp from '../../components/navigation';
import { openModal } from '../../modals';
import { fetchUsers } from '../../redux/thunk/users';
import Spinner from '../../components/ui-helpers/spinner';
import * as resetSearchDataHelper from '../../redux/actions/reset-search-data';

const pathnameToUppercase = str => str.split('')[1].toUpperCase() + str.slice(2);

const mapStateToProps = ({ users, searchTerm, router: { pathname } }) => ({
  pathname,
  users: users.items,
  searchTerm,
});

export const Navigation = R.compose(
  connect(
    mapStateToProps,
    {
      fetchUsers,
      logout,
      openModal,
      setSearchTerm,
      ...resetSearchDataHelper,
    },
  ),
  withState('inputValue', 'setInputValue', ''),
  lifecycle({
    componentDidMount() {
      // Fetch on open subscribe emails window
      if (!!this.props.users && !this.props.isFetching) {
        this.props.fetchUsers();
      }
    },
    componentDidUpdate(prevProps) {
      if (this.props.pathname !== prevProps.pathname && this.props.searchTerm) {
        this.props.setSearchTerm('');
        this.props.setInputValue('');
      }
    },
    componentWillReceiveProps(props) {
      if (props.isInviteUser) {
        this.props.fetchUsers();
      }
    },
  }),
  branch(
    ({ users }) => R.isNil(users) || R.isEmpty(users),
    renderComponent(Spinner),
    mapProps(({
      setIsOpenMobile, users, inputValue, pathname, ...actions
    }) => ({
      pathname,
      inputValue,
      setIsOpenMobile,
      userData: users[localStorage.getItem('userId')],
      onLogout: () => { localStorage.setItem('token', null); actions.logout(); },
      onSearch: ({ target: { value } }) => {
        actions.setInputValue(value.trim().length ? value : value.trim());
        if (inputValue.trim() !== value.trim()) {
          actions.setSearchTerm(value.trim().length ? value : value.trim());
          actions[`resetSearchData${pathnameToUppercase(pathname)}`]({
            prevSearchTerm: actions.searchTerm,
            searchTerm: value.trim().length ? value : value.trim(),
          });
        }
      },
    })),
  ),
)(NavigationComp);



// WEBPACK FOOTER //
// ./src/containers/navigation/index.js